import React, {useContext} from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import Index from "./components/Index/Index";
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import ContactUs from "./components/Credits/Partials/ContactUs";
import Terms from "./components/Credits/Partials/Terms";
import PrivacyPolicy from "./components/Credits/Partials/PrivacyPolicy";
import StockListScreen from "./screens/StockListScreen/StockListScreen";
import {AuthContext, AuthProvider} from "./context/authContext";
import { WaitlistProvider } from './context/waitlistContext';
import {sendToVercelAnalytics} from './vitals';

import {
    indexUrl,
    mobileSupportUrl,
    contactUsUrl,
    privacyUrl,
    termsUrl,
    stockListScreenUrl,
    loginUrl,
    userDashboardUrl,
    discoverStocksUrl,
} from "./Route_urls";


import StockList from "./components/StockList/StockList";
import {ApolloProvider} from '@apollo/client';
import CreditWrapper from "./components/Credits/CreditWrapper";
import Navigation from "./components/Navigation/Navigation";
import 'flowbite';
import SiteApolloClient from "./ApolloClient";
import UserDashboard from "./components/UserDashboard/UserDashboard";
import DiscoverStocks from "./components/UserDashboard/partials/DiscoverStocks/DiscoverStocks";


const ProtectedRoute = ({children}) => {
    const {user} = useContext(AuthContext)
    if (!user) {
        return <Navigate to={loginUrl} replace/>;
    }
    return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <ApolloProvider client={SiteApolloClient}>
            <WaitlistProvider>
            <BrowserRouter>
                <Navigation/>
                <Routes>
                    <Route path={indexUrl} element={<Index/>}/>
                    <Route path={'*'} element={<Index/>}/>

                    {/*<Route path={creditsUrl} element={<CreditWrapper children={<Credits/>} title={'Credits'}/>}/>*/}
                    {/*<Route path={ourStoryUrl} element={<CreditWrapper children={<OurStory/>} title={'Our Story'}/>}/>*/}

                   
               <Route path={contactUsUrl} element={<CreditWrapper children={<ContactUs/>} title={'Contact us'}/>}/>

                    <Route path={termsUrl}
                           element={<CreditWrapper children={<Terms/>} title={'Terms and Conditions'}/>}/>

                          <Route path={privacyUrl}
                              element={<CreditWrapper children={<PrivacyPolicy/>} title={'Privacy Policy'}/>}/>


                    <Route path={mobileSupportUrl} element={<StockList/>}/>

                    <Route path={`${stockListScreenUrl}/:countryName`}
                           element={<StockListScreen/>}/>
                 


                    <Route path={userDashboardUrl} element={
                        <ProtectedRoute>
                            <UserDashboard/>
                        </ProtectedRoute>
                    }/>
                    <Route path={discoverStocksUrl
                    } element={
                        <ProtectedRoute>
                            <DiscoverStocks/>
                        </ProtectedRoute>
                    }/>


                </Routes>
            </BrowserRouter>
            </WaitlistProvider>
        </ApolloProvider>
    </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToVercelAnalytics);
